import React from 'react'
import { createUseStyles, useTheme } from 'react-jss'

import View from '../form/View'
import Header from '../form/Header'
import Footer from '../form/Footer'

const useStyles = createUseStyles(theme => {
  return ({
    root: {
      height: '100%',
      flexDirection: 'column',
      flex: 1
    },
    content: {
      flex: 1,
      flexGrow: 1,
      overflowY: 'auto',
      margin: '0 36px',
      flexDirection: 'column',
      justifyContent: 'flex-start'
    },
    documentTitle: {
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 'bold',
      color: '#454545',
      fontSize: '36px',
      '@media(max-height: 976px)': {
        fontSize: '28px',
      },
    },
    documentContent: {
      fontFamily: 'Montserrat',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: '32px',
      '@media(max-height: 976px)': {
        fontSize: '18px',
      },
    }
  });
})

function RecommendationView (props) {
  const theme = useTheme()
  const styles = useStyles({ ...props, theme })

  return (
    <View className={styles.root}>
      <Header 
        title={"Vamos registrar este momento!"}
        index={props.index} 
        numOfSteps={props.numOfSteps} 
        showMarkers={true}
      />

      <View className={styles.content}>
        <p className={styles.documentTitle}>Instruções para foto</p>
        <p className={styles.documentContent}>1. Não utilize acessórios, tais como óculos escuros e boné</p>
        <p className={styles.documentContent}>2. Posicione a câmera para centralizar sua face</p>
      </View>

      <Footer 
        onBack={() => props.back()}
        onNext={() => props.next()}
        nextLabel={'Continuar'}
      />
    </View>
  )
}

export default RecommendationView